import { localizeNumber } from "../../../../helpers";
import ibsStore from "../../../Stores/IbsSurveyStore"
import { toNumber } from "../../../../helpers";
import { AssetTableViewMode, IbsCountries } from "../../../../Enums/constants";
import { isInternalStyle } from "../../../../ibsHelper";
import { getSurveyResponseValue } from "../../../../Helpers/General/SurveyResponsesHelper";
import { GetMandateDefaultsList } from "../../../../Helpers/DefaultsHelper";

export function handleValidationData(props, referenceToTable, listOfHeaderRows, dataObj) {
    let obj = createValidationTableData(referenceToTable, listOfHeaderRows, dataObj);
    let data = obj[0]
    listOfHeaderRows = obj[1]
    referenceToTable = obj[2]
    return [data, referenceToTable, listOfHeaderRows]
}

export function createValidationTableData(referenceToTable, listOfHeaderRows, dataObj) {
    let mgrBaseReported = 0.0;
    let mgrBaseDefault = 0.0;
    let mgrPerfReported = 0.0;
    let mgrPerfDefault = 0.0;
    let underlyBaseReported = 0.0;
    let underlyBaseDefault = 0.0;
    let underlyPerfReported = 0.0;
    let underlyPerfDefault = 0.0;


    const tryForceUnlocalizedFormatNumber = (input, returnOnFailure) => {

        if (typeof input === "undefined" || input === null) {
            return returnOnFailure;
        }

        let tryNumber = 0;
        try {
            tryNumber = toNumber(input);
        }
        catch { return returnOnFailure; }

        if (typeof tryNumber !== "number" || isNaN(tryNumber)) {
            return returnOnFailure;
        }
        return tryNumber;
    };


    let isMandateLevel = parseInt(getSurveyResponseValue("IsMandateLevel"))
    if (isMandateLevel === AssetTableViewMode.MANDATE_ONLY_VIEW) {
        const defaults = GetMandateDefaultsList();

        for (const mandate of ibsStore.mandateData) {
            mgrBaseReported += tryForceUnlocalizedFormatNumber(mandate["costManagerBase"], 0);
            mgrPerfReported += tryForceUnlocalizedFormatNumber(mandate["costManagerPerf"], 0);
            underlyBaseReported += tryForceUnlocalizedFormatNumber(mandate["costUnderlyBase"], 0);
            underlyPerfReported += tryForceUnlocalizedFormatNumber(mandate["costUnderlyPerf"], 0);
        }

        for (const mandateDefault of defaults) {
            const valueFromMandateDefault = tryForceUnlocalizedFormatNumber(parseFloat(toNumber(mandateDefault["value"])), null);
            if (valueFromMandateDefault === null) {
                continue;
            }

            switch (mandateDefault["qName"]) {
                case "costManagerBase":
                    mgrBaseDefault += valueFromMandateDefault;
                    break;
                case "costManagerPerf":
                    mgrPerfDefault += valueFromMandateDefault;
                    break;
                case "costUnderlyBase":
                    underlyBaseDefault += valueFromMandateDefault;
                    break;
                case "costUnderlyPerf":
                    underlyPerfDefault += valueFromMandateDefault;
                    break;
                default:
                    break;
            }
        }

    } else if (isMandateLevel === AssetTableViewMode.ASSET_ONLY_VIEW) {
        for (const asset of ibsStore.allTableResponses["combinedAssets"]) {
            mgrBaseReported += tryForceUnlocalizedFormatNumber(asset["CostBaseFeesThousands"], 0);
            mgrPerfReported += tryForceUnlocalizedFormatNumber(asset["CostPerformanceThousands"], 0);
            underlyBaseReported += tryForceUnlocalizedFormatNumber(asset["UnderlyingFundFees"], 0);
            underlyPerfReported += tryForceUnlocalizedFormatNumber(asset["UnderlyingPerfFees"], 0);
        }

    } else if (isMandateLevel === AssetTableViewMode.BOTH_VIEW) {
        for (const asset of ibsStore.allTableResponses["combinedAssets"]) {
            const correspondingMandates = ibsStore.mandateData?.filter(mandate => mandate.assetClassID === asset.AssetClassID && mandate.styleID === asset.StyleID)

            if (asset["CostBaseFeesThousands"]) {
                mgrBaseReported += tryForceUnlocalizedFormatNumber(asset["CostBaseFeesThousands"], 0);
            }
            else {
                for (const mandate of correspondingMandates) {
                    mgrBaseReported += tryForceUnlocalizedFormatNumber(mandate["costManagerBase"], 0);
                }
            }

            if (asset["CostPerformanceThousands"]) {
                mgrPerfReported += tryForceUnlocalizedFormatNumber(asset["CostPerformanceThousands"], 0);
            }
            else {
                for (const mandate of correspondingMandates) {
                    mgrPerfReported += tryForceUnlocalizedFormatNumber(mandate["costManagerPerf"], 0);
                }
            }

            if (asset["UnderlyingFundFees"]) {
                underlyBaseReported += tryForceUnlocalizedFormatNumber(asset["UnderlyingFundFees"], 0);
            }
            else {
                for (const mandate of correspondingMandates) {
                    underlyBaseReported += tryForceUnlocalizedFormatNumber(mandate["costUnderlyBase"], 0);
                }
            }

            if (asset["UnderlyingPerfFees"]) {
                underlyPerfReported += tryForceUnlocalizedFormatNumber(asset["UnderlyingPerfFees"], 0);
            }
            else {
                for (const mandate of correspondingMandates) {
                    underlyPerfReported += tryForceUnlocalizedFormatNumber(mandate["costUnderlyPerf"], 0);
                }
            }
        }
        const defaults = GetMandateDefaultsList();
        for (const mandateDefault of defaults) {
            const valueFromMandateDefault = tryForceUnlocalizedFormatNumber(parseFloat(toNumber(mandateDefault["value"])), null);
            if (valueFromMandateDefault === null) {
                continue;
            }
            switch (mandateDefault["qName"]) {
                case "costManagerBase":
                    mgrBaseDefault += valueFromMandateDefault;
                    break;
                case "costManagerPerf":
                    mgrPerfDefault += valueFromMandateDefault;
                    break;
                case "costUnderlyBase":
                    underlyBaseDefault += valueFromMandateDefault;
                    break;
                case "costUnderlyPerf":
                    underlyPerfDefault += valueFromMandateDefault;
                    break;
                default:
                    break;
            }
        }
    }

    const subTotalReported = mgrBaseReported + mgrPerfReported + underlyBaseReported + underlyPerfReported;
    const subTotalDefault = mgrBaseDefault + mgrPerfDefault + underlyBaseDefault + underlyPerfDefault;
    const subTotalTotal = mgrBaseReported + mgrBaseDefault +
        mgrPerfReported + mgrPerfDefault +
        underlyBaseReported + underlyBaseDefault +
        underlyPerfReported + underlyPerfDefault;

    let totalReported = subTotalReported;
    let totalDefault = subTotalDefault;
    let totalTotal = subTotalTotal;

    const rowData = [
        { FeeType: "Manager Fees" },
        { FeeType: "&nbsp;&nbsp;&nbsp;&nbsp;Base Fees", Reported: localizeNumber(mgrBaseReported), Default: localizeNumber(mgrBaseDefault), Total: localizeNumber(mgrBaseReported + mgrBaseDefault) },
        { FeeType: "&nbsp;&nbsp;&nbsp;&nbsp;Performance Fees", Reported: localizeNumber(mgrPerfReported), Default: localizeNumber(mgrPerfDefault), Total: localizeNumber(mgrPerfReported + mgrPerfDefault) },
        { FeeType: "&nbsp;&nbsp;&nbsp;&nbsp;Underlying Base Fees", Reported: localizeNumber(underlyBaseReported), Default: localizeNumber(underlyBaseDefault), Total: localizeNumber(underlyBaseReported + underlyBaseDefault) },
        { FeeType: "&nbsp;&nbsp;&nbsp;&nbsp;Underlying Performance Fees", Reported: localizeNumber(underlyPerfReported), Default: localizeNumber(underlyPerfDefault), Total: localizeNumber(underlyPerfReported + underlyPerfDefault) },
        { FeeType: "&nbsp;&nbsp;&nbsp;&nbsp;Sub Total", Reported: localizeNumber(subTotalReported), Default: localizeNumber(subTotalDefault), Total: localizeNumber(subTotalTotal) },
    ];
    listOfHeaderRows.push(0) // First row is a header

    let internalInvestmentManagement = 0;
    let governanceOperationsSupport = 0;

    // Calculate Internal Investment Management row
    if (parseInt(ibsStore.currentSurvey.EnhancedInternalID) === 2) {
        if (ibsStore?.allTableResponses["FrontOffice"]) {
            for (let row of ibsStore.allTableResponses["FrontOffice"]) {
                internalInvestmentManagement += tryForceUnlocalizedFormatNumber(row["Costs"], 0);
            }
        }
    }
    else {
        if (isMandateLevel === AssetTableViewMode.MANDATE_ONLY_VIEW && ibsStore.mandateData) {
            for (let mandate of ibsStore.mandateData) {
                internalInvestmentManagement += tryForceUnlocalizedFormatNumber((isInternalStyle(mandate.styleID) ? mandate["costInternManage"] : mandate["costInternMonitor"]), 0);
            }
        }
        if (isMandateLevel === AssetTableViewMode.ASSET_ONLY_VIEW && ibsStore?.allTableResponses["combinedAssets"]) {
            for (let asset of ibsStore.allTableResponses["combinedAssets"]) {
                internalInvestmentManagement += tryForceUnlocalizedFormatNumber((isInternalStyle(asset.StyleID) ? asset["CostThousands"] : asset["InternalMonitoringCost"]), 0);
            }
        }
        if (isMandateLevel === AssetTableViewMode.BOTH_VIEW && ibsStore?.allTableResponses["combinedAssets"]) {
            for (const asset of ibsStore.allTableResponses["combinedAssets"]) {

                const correspondingMandates = ibsStore.mandateData
                    .filter(mandate => mandate.assetClassID === asset.AssetClassID && mandate.styleID === asset.StyleID);
                let tempInternalMonCost = tryForceUnlocalizedFormatNumber((isInternalStyle(asset.StyleID) ? asset["CostThousands"] : asset["InternalMonitoringCost"]), null);
                if (tempInternalMonCost) {
                    internalInvestmentManagement += tempInternalMonCost;
                }
                else {
                    for (const mandate of correspondingMandates) {
                        internalInvestmentManagement += tryForceUnlocalizedFormatNumber((isInternalStyle(mandate.styleID) ? mandate["costInternManage"] : mandate["costInternMonitor"]), 0);
                    }
                }
            }
        }
        if (ibsStore.currentSurvey && parseInt(ibsStore.currentSurvey["CountryID"]) === IbsCountries.UK && Math.abs(internalInvestmentManagement) < 0.001) {
            let internalManagementCost = tryForceUnlocalizedFormatNumber(parseFloat(toNumber(ibsStore.allResponses["InternalManagementCost"])), 0);
            let externalManagementCost = tryForceUnlocalizedFormatNumber(parseFloat(toNumber(ibsStore.allResponses["ExternalManagementCost"])), 0);
            internalInvestmentManagement = internalManagementCost + externalManagementCost;
        }

    }

    // Calculate Governance, Operations, Support row
    if (parseInt(ibsStore.currentSurvey.EnhancedInternalID) === 2 && ibsStore.currentSurvey.PlanPartnershipID == 2) {
        if (ibsStore?.allTableResponses["Expenses"]) {
            for (let row of ibsStore.allTableResponses["Expenses"]) {
                governanceOperationsSupport += tryForceUnlocalizedFormatNumber(row["SupportCosts"], 0);
            }
        }
    }
    else if (parseInt(ibsStore.currentSurvey.EnhancedInternalID) === 2) {
        if (ibsStore?.allTableResponses["Expenses"]) {
            for (let row of ibsStore.allTableResponses["Expenses"]) {
                governanceOperationsSupport += tryForceUnlocalizedFormatNumber(row["SupportCosts"], 0);
            }
        }
    }
    else if (ibsStore.currentSurvey.PlanPartnershipID === 2) {
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["Oversight_Plan"], 0);
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["Consulting_Plan"], 0);
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["CustodialTot_Plan"], 0);
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["Audit_Plan"], 0);
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["LiabilityReduction_Plan"], 0);
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["Other_Plan"], 0);
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["Oversight_Co"], 0);
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["Consulting_Co"], 0);
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["CustodialTot_Co"], 0);
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["Audit_Co"], 0);
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["LiabilityReduction_Co"], 0);
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["Other_Co"], 0);

    }
    else {
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["CExecAdmin"], 0);
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["CConsultOrPM"], 0);
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["CCustTot"], 0);
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["CAudit"], 0);
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["FiduciaryManagementFee"], 0);
        governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["CGOther"], 0);
        if (ibsStore.currentSurvey.PlanPartnershipID === 6) {
            governanceOperationsSupport += tryForceUnlocalizedFormatNumber(ibsStore?.allResponses["LGPSPoolOversight"], 0);
        }
    }

    const internalInvestmentManagementRow = {
        FeeType: "Internal Investment Management",
        Reported: localizeNumber(internalInvestmentManagement),
        Default: 0,
        Total: localizeNumber(internalInvestmentManagement)
    };
    const governanceOperationsSupportRow = {
        FeeType: "Governance, Operations, Support",
        Reported: localizeNumber(governanceOperationsSupport),
        Default: 0,
        Total: localizeNumber(governanceOperationsSupport)
    };

    rowData.push(internalInvestmentManagementRow)
    rowData.push(governanceOperationsSupportRow)

    totalReported += internalInvestmentManagement + governanceOperationsSupport;
    totalDefault += internalInvestmentManagementRow.Default + governanceOperationsSupportRow.Default;
    totalTotal += internalInvestmentManagement + governanceOperationsSupport;

    rowData.push({ FeeType: "Total (excl. Transaction Costs)", Reported: localizeNumber(totalReported), Default: localizeNumber(totalDefault), Total: localizeNumber(totalTotal) })

    referenceToTable = rowData;
    dataObj = rowData;
    return [dataObj, listOfHeaderRows, referenceToTable];
;
}
